import { useMemo } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import { resolvePlatformFeatures } from 'src/utils/platform-features';

import { usePlatforms } from './use-platforms';

export const useActivePlatform = () => {
  const { platformId } = useAuthContext();
  const { data: platforms, isLoading } = usePlatforms();

  const currentPlatform = useMemo(() => {
    if (!platformId || !platforms.length) {
      return null;
    }
    return platforms.find((platform) => platform.id === platformId) || null;
  }, [platformId, platforms]);

  const userRole = useMemo(() => {
    return currentPlatform?.role;
  }, [currentPlatform]);

  const permissionMatrix = currentPlatform?.permission_matrix ?? null;
  const roleId = currentPlatform?.role_id ?? null;

  const features = useMemo(() => resolvePlatformFeatures(currentPlatform), [currentPlatform]);

  return {
    userRole,
    permissionMatrix,
    roleId,
    features,
    platform: currentPlatform,
    isLoading,
  };
};
